import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import ProvinciaTabla from '../types/ProvinciaTabla';
import SeleccionarPais from './SeleccionarPais';
import ObtenerProvincia from '../functions/ObtenerProvincia';
import ObtenerPais from '../functions/ObtenerPais';
import PaisSeleccionar from '../types/PaisSeleccionar';
import ProvinciaSeleccionar from '../types/ProvinciaSeleccionar';
import LocalidadTabla from '../types/LocalidadTabla';
import ObtenerLocalidades from '../functions/ObtenerLocalidades';

interface ListarLocalidadesProps {
    defaultItemsPerPage?: number;
    handleEdit: (localidad: LocalidadTabla) => void;
    handleDelete: (localidad: LocalidadTabla) => void;
    handleAdd: () => void;
    pais: PaisSeleccionar;
    provincia: ProvinciaSeleccionar;
}

export const ListarLocalidades: React.FC<ListarLocalidadesProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, pais, provincia}) => {
  
  const [localidades, setLocalidades] = useState<LocalidadTabla[]>([]);
  const [nombrePais, setNombrePais] = useState<string>('');
  const [nombreProvincia, setNombreProvincia] = useState<string>('');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  const cargarPais = async (idPais: number) => {
    const respuesta = await ObtenerPais(idPais);
    return respuesta;
  };

  const cargarProvincia = async (idProvincia: number) => {
    const respuesta = await ObtenerProvincia(idProvincia);
    return respuesta;
  };

  const handleMostrarCredencial = (localidad: LocalidadTabla) => {
    console.log('Mostrar credencial', localidad);
  };

  const handleUbication = (localidad: LocalidadTabla) => {
    console.log('Mostrar ubicacion', localidad);
  };
  
  useEffect(() => {
    const fetchLocalidades = async () => {
      try {
        const paisData = await ObtenerPais(pais.id);
        const provinciaData = await ObtenerProvincia(provincia.id);
        const data = await ObtenerLocalidades(paisData.pais[0].id, provinciaData.provincia[0].id);
        
        const localidadesRecuperadas: LocalidadTabla[] = [];

        for (const localidad of data.localidades) {
          localidadesRecuperadas.push({
            id: localidad.id,
            codpostal: localidad.codpostal,
            localidad: localidad.localidad,
            habilitado: localidad.habilitado,
            fch_crea: localidad.fch_crea,
            fch_modi: localidad.fch_modi,
            dado_baja: localidad.dado_de_baja,
            fch_baja: localidad.fch_baja,
            pais_id: paisData.pais[0].id,
            pais_nombre: paisData.pais[0].nombre,
            provincia_id: provinciaData.provincia[0].id,
            provincia_nombre: provinciaData.provincia[0].provincia
          });
        };

        setLocalidades(localidadesRecuperadas);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener las localidades: ' + err);
        setLoading(false);
      }
    };

    fetchLocalidades();
  
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'codpostal', label: 'COD.POSTAL', align: 'left' as const },
    { key: 'localidad', label: 'LOCALIDAD', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'dado_baja', label: 'BAJA', align: 'center' as const },
  ];

  const handleEditLocal = (localidad: LocalidadTabla) => {
    handleEdit(localidad);
  };

  const handleDeleteLocal = (localidad: LocalidadTabla) => {
    handleDelete(localidad);
  };


  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-2 mt-2">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Localidades cargadas de {pais.name} - {provincia.name}</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nueva Localidad</button>
        </div>
      </div>
      <Tabla columns={columns} data={localidades} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleMostrarCredencial} onUbication={handleUbication} acciones={['editar','eliminar']}/>
    </div>
  );
};